import React from 'react';

/**
 * Coin-style badge overlay for avatars.
 * kind: 'host' (gold, top-left) | 'dealer' (red gradient, top-right)
 */
function AvatarBadgeChip({ kind, className = '' }) {
  const label = kind === 'dealer' ? 'D' : 'H';
  const chipClass = [
    'avatar-badge-chip',
    kind === 'dealer' ? 'avatar-badge-chip--dealer' : 'avatar-badge-chip--host',
    className,
  ].filter(Boolean).join(' ');

  return (
    <span
      className={chipClass}
      title={kind === 'dealer' ? 'Dealer' : 'Table host'}
      aria-hidden
    >
      {label}
    </span>
  );
}

export default AvatarBadgeChip;